/**
 * Configuración del generador de rutas dinámicas
 * Permite personalizar el comportamiento del sistema
 */

// Configuración por defecto
export const DEFAULT_CONFIG = {
    // Habilitar logs de debug
    enableDebug: false,
    
    // Prefijo para las keys de rutas dinámicas
    routeKeyPrefix: 'dynamic-',
    
    // Componente por defecto si no se encuentra mapeo
    defaultComponent: 'PanelGerencia',
    
    // Patrones de rutas a ignorar
    ignorePatterns: [
        '/api/',
        '/assets/',
        '/static/',
        '/_next/',
        '/favicon.ico'
    ],
    
    // Mapeo personalizado de palabras clave a componentes
    customComponentMapping: {
        // Puedes agregar mapeos personalizados aquí
        // 'custom-action': 'CustomComponent'
    },
    
    // Configuración de performance
    performance: {
        // Tiempo máximo permitido para generar rutas (ms)
        maxGenerationTime: 50,
        
        // Número máximo de rutas dinámicas permitidas
        maxDynamicRoutes: 1000,
        
        // Habilitar medición de performance
        measurePerformance: process.env.NODE_ENV === 'development'
    }
};

/**
 * Configuración específica por entorno
 */
export const ENVIRONMENT_CONFIG = {
    development: {
        ...DEFAULT_CONFIG,
        enableDebug: true,
        performance: {
            ...DEFAULT_CONFIG.performance,
            measurePerformance: true
        }
    },
    
    production: {
        ...DEFAULT_CONFIG,
        enableDebug: false,
        performance: {
            ...DEFAULT_CONFIG.performance,
            measurePerformance: false
        }
    },
    
    test: {
        ...DEFAULT_CONFIG,
        enableDebug: false,
        performance: {
            ...DEFAULT_CONFIG.performance,
            measurePerformance: false,
            maxGenerationTime: 10
        }
    }
};

/**
 * Obtiene la configuración para el entorno actual
 */
export const getCurrentConfig = () => {
    const env = process.env.NODE_ENV || 'development';
    const config = ENVIRONMENT_CONFIG[env] || DEFAULT_CONFIG;
    
    return config;
};

/**
 * Configuración de mapeo avanzado
 * Permite definir reglas más complejas para el mapeo de componentes
 */
export const ADVANCED_MAPPING_RULES = [
    {
        // Regla para rutas de administración
        pattern: /\/administrar$/,
        component: 'Investigaciones',
        priority: 10
    },
    {
        // Regla para rutas de solicitud
        pattern: /\/solicitar$/,
        component: 'Inteligencia',
        priority: 10
    },
    {
        // Regla para rutas de reportes
        pattern: /\/reportes$/,
        component: 'Operaciones',
        priority: 10
    },
    {
        // Regla para rutas de reportes operativos
        pattern: /\/reportes_operativos$/,
        component: 'ReportesOperativos',
        priority: 10
    },
    {
        // Regla para rutas de procesos
        pattern: /\/procesos$/,
        component: 'ReportesOperativos',
        priority: 10
    },
    {
        // Regla para paneles y dashboards
        pattern: /\/(panel|dashboard)/,
        component: 'PanelGerencia',
        priority: 5
    }
];

/**
 * Función para obtener componente basado en reglas avanzadas
 */
export const getComponentByAdvancedRules = (path) => {
    const matchingRules = ADVANCED_MAPPING_RULES
        .filter(rule => rule.pattern.test(path))
        .sort((a, b) => b.priority - a.priority);
    
    return matchingRules.length > 0 ? matchingRules[0].component : null;
};
